import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@ui/dialog-v2/dialog.tokens';
import { FormChangeInvoiceStatusComponent } from '../form-change-invoice-status/form-change-invoice-status.component';
import { RxEffects } from '@rx-angular/state/effects';
import { AsyncPipe } from '@angular/common';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { B2bProgramInvoicesState } from '../../../../shared/state/b2b-program-invoices.state';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { parseNumber } from '@libs/functions';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-change-invoice-status',
    templateUrl: './change-invoice-status-dialog.component.html',
    styleUrls: ['./change-invoice-status-dialog.component.scss'],
    imports: [FormChangeInvoiceStatusComponent, AsyncPipe],
    providers: [RxEffects],
})
export class ChangeInvoiceStatusDialogComponent {
    readonly #effects: RxEffects = inject(RxEffects);
    readonly #push: PushService = inject(PushService);
    readonly #data: DialogData = inject(MAT_DIALOG_DATA);
    readonly #b2bProgramInvoicesState: B2bProgramInvoicesState = inject(B2bProgramInvoicesState);

    public readonly dialogRef: MatDialogRef<ChangeInvoiceStatusDialogComponent> = inject(MatDialogRef);
    public readonly pending$: Observable<boolean> = this.#b2bProgramInvoicesState.loading$.pipe(
        getLoadingProp(StartWithUnit.SetB2BProgramInvoiceStatus),
    );

    public readonly stCode: number = parseNumber(this.#data.params?.serviceParams?.stCode);
    public readonly invId: number = parseNumber(this.#data.params?.serviceParams?.invId);

    public handlerConfirm(stCode: number): void {
        this.#effects.register(this.#b2bProgramInvoicesState.changeInvoiceStatus({ invId: this.invId, stCode }), () => {
            this.#push.success(PushCodeModel.SuccessChange);
            this.dialogRef.close();
        });
    }
}
